<template>
  <section>
    <div class="t-headline10 mgt-50 pdt-6 mgb-16 font-m t-color-headline-black">
      {{ $t('30079') }}
    </div>
  <div class="d-flex mgb-10">
    <div class="mdc-chip-set tab-chip chip--outlined main-header" role="grid">
      <div v-for="(tag, index) in tags" :key="index" class="mdc-chip pdl-20 pdr-20 cursor-pointer" role="row">
        <div class="mdc-chip__ripple"></div>
        <span role="gridcell">
            <span class="mdc-chip__text t-body1 font-r">#{{ tag.name }}</span>
        </span>
      </div>

    </div>
  </div>
  </section>
</template>

<script>
export default {
  name: "Tag",

  props: ['tags']
}
</script>

<style scoped>

</style>
